import type {UseEntityData} from "crqlar-react-common/dist/components/useEntity";
import type {EliteConfig} from "crqlar-react-common/dist/models/integrations/elite/eliteConfig.model";
import {EliteService} from "crqlar-react-common/dist/services/integrations/elite/elite.service";
import StatsImportLogsTable from "../../common/StatsImportLogsTable";

interface Props {
    eliteConfigData: UseEntityData<EliteConfig>
}

const Logs = ({eliteConfigData}: Props) => (
    <StatsImportLogsTable
        configId={eliteConfigData.item.id}
        getStats={EliteService.getStats}
        connectorId="elite"
    />
);

export default Logs;
